import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Form } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

const IntentForm = () => {
  const [trainLanguage, setTrainLanguage] = useState("en");
  const [intents, setIntents] = useState([
    {
      tag: "",
      patterns: [""],
      responses: [""],
      context_set: "",
    },
  ]);

  const handleChange = (index, field, value) => {
    const newIntents = [...intents];
    if (field === "tag") {
      newIntents[index].tag = value;
    } else if (field === "patterns") {
      newIntents[index].patterns = value
        .split(",")
        .map(pattern => pattern.trim());
    } else if (field === "responses") {
      newIntents[index].responses = value
        .split(",")
        .map(response => response.trim());
    } else if (field === "context_set") {
      newIntents[index].context_set = value;
    }
    setIntents(newIntents);
  };
  // console.log("intents",intents)
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const response = await fetch("https://13.202.189.116:8081/add/in", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          train_language: trainLanguage,
          intents: JSON.stringify(intents),
        }),
      });

      if (response.ok) {
        alert("Intents added successfully!");
        // Reset form or handle success
      } else {
        alert("Failed to add intents. Please check the server.");
      }
    } catch (error) {
      console.error("Network error:", error);
      alert("Failed to fetch. Please check your network or server.");
    }
  };

  const addIntent = () => {
    setIntents([
      ...intents,
      { tag: "", patterns: [""], responses: [""], context_set: "" },
    ]);
  };

  return (
    <div className="page-content">
      <div className="joblist-container create-vacancy">
        <Row className="mb-3 align-items-center depart-content">
          <Col lg="6" md="6">
            <Link to="/bot-dashboard">
              <h5 className="text-uppercase heading-one">
                <img src={arrow_btn} alt="arrow_btn" />
                Intent Form
              </h5>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="outerTab-box-wrapper below-vacancy">
        <div className="form-details-section mt-3">
          <form onSubmit={handleSubmit} className="">
            <div className="row">
              <div className="col-md-6">
                {/* Train Language */}
                <div className="mb-3">
                  <label className="form-label">Train Language:</label>
                  <select
                    className="form-select form-control"
                    value={trainLanguage}
                    onChange={e => setTrainLanguage(e.target.value)}
                    onMouseEnter={e => {
                      e.target.setAttribute(
                        "title",
                        e.target.options[e.target.selectedIndex].text
                      );
                    }}
                  >
                    <option value="en">English (en)</option>
                    <option value="es">Spanish (es)</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Dynamic Intents */}
            {intents.map((intent, index) => (
              <div key={index} className="">
                {/* <h4 className="mb-3">Intent {index + 1}</h4> */}
                <div className="row g-3">
                  <div className="col-md-6">
                    <label
                      htmlFor={`tag-input-${index}`}
                      className="form-label"
                    >
                      Tag:
                    </label>
                    <input
                      type="text"
                      id={`tag-input-${index}`}
                      className="form-control"
                      value={intent.tag}
                      onChange={e => handleChange(index, "tag", e.target.value)}
                      title="Tag"
                    />
                  </div>

                  <div className="col-md-6">
                    <label
                      htmlFor={`context-set-input-${index}`} /* Link the label to the input */
                      className="form-label"
                    >
                      Context Set:
                    </label>
                    <input
                      type="text"
                      id={`context-set-input-${index}`} /* Unique id for the input */
                      className="form-control"
                      value={intent.context_set}
                      onChange={e =>
                        handleChange(index, "context_set", e.target.value)
                      }
                      title="Context Set"
                    />
                  </div>

                  <div className="col-md-6">
                    <label
                      htmlFor={`patterns-input-${index}`}
                      className="form-label"
                    >
                      Patterns (comma separated):
                    </label>
                    <input
                      type="text"
                      id={`patterns-input-${index}`}
                      className="form-control"
                      value={intent.patterns.join(", ")}
                      onChange={e =>
                        handleChange(index, "patterns", e.target.value)
                      }
                      title="Patterns (comma separated)"
                    />
                  </div>

                  <div className="col-md-6">
                    <label
                      htmlFor={`responses-input-${index}`}
                      className="form-label"
                    >
                      Responses (comma separated):
                    </label>
                    <input
                      type="text"
                      id={`responses-input-${index}`}
                      className="form-control"
                      value={intent.responses.join(", ")}
                      onChange={e =>
                        handleChange(index, "responses", e.target.value)
                      }
                      title="Responses (comma separated)"
                    />
                  </div>
                </div>
              </div>
            ))}

            {/* Buttons */}
            <div className="cta text-center d-flex justify-content-start gap-2 mt-4 pb-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={addIntent}
              >
                Add Another Intent
              </button>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default IntentForm;
